module.exports = __webpack_public_path__ + "assets/img/SG_003.4a234850.png";